import {
  API_BASE_URL,
  DEFAULT_GUEST_URL,
  DEFAULT_GUEST_URL_PAT,
  DEFAULT_STUDIO_URL,
  DEFAULT_STUDIO_URL_PAT,
  IS_PRODUCTION,
} from '~/store/env/initialState';
import { getExchangeToken } from '../services';

export const needsExchangeToken = () => {
  // logic to detect cisco device.
  // we can change this later if we need to do this for other devices, or use different methods
  const matchString = 'roomos'; // uncomment this to test for real
  return navigator.userAgent.toLowerCase().includes(matchString);
};

export const normalizeStudioURL = async (url, hash, version, composerTokens) => {
  let studioURL = '';
  // DANGER!!! guest.html removed here to work with guest refactor.
  // Do not release this change to production before cutover to refactor.
  const hostOrGuest = '';
  // only bust cache in non-prod envs. we only currently have one prod env for portal, but may change in the future
  // this may be a temporary solution and should end up in our new .conf files, so doing this in a simpler way for now. should also be a selector now that redux is available.
  const cacheBusterParam = !window.CONFIG.isProduction ? `&c=${Date.now()}` : '';

  if (IS_PRODUCTION) {
    studioURL = `${url}${hostOrGuest}?hash=${hash}&v=${version}${cacheBusterParam}`;
  } else if (composerTokens) {
    const { appId, agoraToken, brokerToken, sfu } = composerTokens;
    studioURL = `${url}/?agoraAppId=${appId}&agoraToken=${agoraToken}&brokerToken=${brokerToken}&sfuName=agora&sfu=${sfu}&hash=${hash}&host=${API_BASE_URL}&testButtons=1`;
  } else {
    studioURL = `${url}${hostOrGuest}?hash=${hash}&host=${API_BASE_URL}&v=${version}${cacheBusterParam}`;
  }

  if (!studioURL.startsWith('https://') && !studioURL.startsWith('http://')) {
    // eslint-disable-next-line no-console
    console.warn('no protocol available: URL', studioURL);
    studioURL = `https://${studioURL}`;
  }

  const needsToken = needsExchangeToken();
  if (needsToken) {
    const exchangeToken = await getExchangeToken();
    if (exchangeToken) {
      studioURL = `${studioURL}&jwt=${exchangeToken}`;
    }
  }

  return studioURL;
};

export const getStudioURL = (studioURLOverride, isHost) => {
  let studioURL;
  if (isHost) {
    studioURL = document.location.host === 'pat.socialive.us' ? DEFAULT_STUDIO_URL_PAT : DEFAULT_STUDIO_URL;
  } else {
    studioURL = document.location.host === 'pat.socialive.us' ? DEFAULT_GUEST_URL_PAT : DEFAULT_GUEST_URL;
  }

  studioURL = `${document.location.protocol}//${studioURL}`;

  if (studioURLOverride !== 'null' && studioURLOverride !== null) {
    studioURL = studioURLOverride;
  }

  return studioURL;
};
